export const videos = [
  {
    id: 'v1',
    title: '顶流男星酒店监控曝光完整版',
    slug: 'top-male-star-hotel-mystery-woman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Surveillance%20camera%20footage%20style%20frame%20with%20timecode%2C%20hotel%20corridor%20grainy%20night%20vision%20green%20tint%2C%20mysterious%20figure%20walking%2C%20documentary%20investigation%20aesthetic%2C%20dark%20atmosphere%2C%20warm%20amber%20overlay%20tones&width=640&height=360&seq=video-01&orientation=landscape',
    duration: '12:45',
    views: 128456,
    date: '2026-07-02',
    category: '娱乐八卦',
  },
  {
    id: 'v2',
    title: '女星片场发飙原声视频流出',
    slug: 'actress-diva-behavior-set',
    thumbnail: 'https://readdy.ai/api/search-image?query=Film%20set%20microphone%20and%20boom%20pole%20close-up%2C%20dramatic%20studio%20lighting%2C%20audio%20equipment%20details%2C%20warm%20tungsten%20glow%2C%20cinematic%20behind-the-scenes%20photography%2C%20professional%20production%20atmosphere&width=640&height=360&seq=video-02&orientation=landscape',
    duration: '08:32',
    views: 98765,
    date: '2026-07-01',
    category: '明星黑料',
  },
  {
    id: 'v3',
    title: '网红直播翻车现场实录',
    slug: 'influencer-livestream-privacy-leak',
    thumbnail: 'https://readdy.ai/api/search-image?query=Smartphone%20live%20stream%20setup%20with%20ring%20light%20and%20camera%20equipment%2C%20dark%20room%20environment%2C%20neon%20accent%20lights%2C%20content%20creator%20studio%2C%20warm%20and%20cool%20light%20mix%2C%20editorial%20tech%20photography&width=640&height=360&seq=video-03&orientation=landscape',
    duration: '15:20',
    views: 156789,
    date: '2026-07-01',
    category: '网红资讯',
  },
  {
    id: 'v4',
    title: '导演潜规则录音完整版',
    slug: 'director-casting-couch-recording',
    thumbnail: 'https://readdy.ai/api/search-image?query=Audio%20waveform%20visualization%20on%20dark%20screen%2C%20sound%20frequency%20patterns%20in%20warm%20orange%20and%20red%20gradient%2C%20digital%20audio%20interface%2C%20investigation%20evidence%20theme%2C%20editorial%20digital%20art%20style%2C%20high%20contrast&width=640&height=360&seq=video-04&orientation=landscape',
    duration: '22:18',
    views: 234567,
    date: '2026-06-30',
    category: '丑闻曝光',
  },
];
